// extracted by mini-css-extract-plugin
export var attachment = "_ps-a";
export var emailContainer = "_ps-4";
export var emailContentPaddedContainer = "_ps-b";
export var emailHeader = "_ps-6";
export var emailIframe = "_ps-3";
export var emailInfoIcon = "_ps-9";
export var emailShortenedSummary = "_ps-e";
export var infoDropdown = "_ps-0";
export var infoRowBoundedContent = "_ps-d";
export var internal = "_ps-5";
export var merchant = "_ps-8";
export var messageInputContainer = "_ps-h";
export var normal = "_ps-7";
export var replyCard = "_ps-f";
export var subtleButton = "_ps-1";
export var subtleButtonIconContainer = "_ps-2";
export var toggleViewRepliesButton = "_ps-c";
export var wrappingText = "_ps-g";